export default __webpack_public_path__ + "static/media/17.ccb7a3a0.png";